import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gt-object-card" }
const _hoisted_2 = { class: "gt-object-card__head gt-space_mb gt-space_mb--4" }
const _hoisted_3 = { class: "gt-object-card__select-btn" }
const _hoisted_4 = { class: "gt-object-card__body" }
const _hoisted_5 = { class: "gt-object-card__name gt-space_mb gt-space_mb--4" }
const _hoisted_6 = { class: "gt-object-card__info" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "gt-object-card__icon gt-space_mr gt-space_mr--2" }
const _hoisted_9 = { class: "gt-object-card__company" }
const _hoisted_10 = { class: "gt-object-card__icon gt-space_mr gt-space_mr--2" }
const _hoisted_11 = { class: "gt-object-card__bottom gt-space_mt gt-space_mt--4" }
const _hoisted_12 = { class: "gt-object-card__date" }
const _hoisted_13 = { class: "gt-object-card__buttons" }
const _hoisted_14 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }
const _hoisted_15 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_phone = _resolveComponent("i-phone")!
  const _component_i_user_small = _resolveComponent("i-user-small")!
  const _component_i_edit = _resolveComponent("i-edit")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "select")
      ]),
      _createElementVNode("div", {
        class: "gt-object-card__status",
        style: _normalizeStyle({ backgroundColor: $props.colors[$props.seller?.[$props.statusType]].color })
      }, [
        _createElementVNode("span", null, _toDisplayString($props.statuses[$props.seller?.[$props.statusType]]), 1)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(`${$setup.lastName} ${$setup.firstName}`), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "gt-object-card__phone ds-link hovered_underline",
          href: `tel:${$setup.phone}`
        }, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_i_phone)
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.phone), 1)
        ], 8, _hoisted_7),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_i_user_small)
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.outlet), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, _toDisplayString($setup.dateJoined), 1),
      _createElementVNode("div", _hoisted_13, [
        ($props.updatePageLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "gt-object-card__more-btn ds-link gt-space_mr gt-space_mr--5",
              to: { name: $props.updatePageLink, params: { id: $setup.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString($setup.$t('Edit')), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_i_edit)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: "gt-object-card__more-btn ds-link",
          to: { name: $props.detailsPageLink, params: { id: $setup.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString($setup.$t('Details')), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_i_arrow_right)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}